define('models/validator/cardnumbermastercard',["backbone",
        "models/validator/_base/basevalidator"
], function (Backbone, BaseValidator) {
    "use strict";

    return BaseValidator.extend({

        defaults: {
            validationType: enums.validationType.cardNumberMasterCard
        },

        validate: function(val) {
            val = val.replace(/[ -]/g, ''), // Strip spaces and dashes
            this.set('value', val);

            var code = this.validateHasValue(val);
            if ( this.isValid(code) ) {
                code = this.validateCardNumberMasterCard(val);
            }
            
            this.set('validationCode', code);
            return code;
        },

        validateCardNumberMasterCard: function(val) {
            var code;
            if (/^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/.test(val)) {// MasterCard card number regex
                code = enums.validationCode.ok;
            } else {
                code = enums.validationCode.incorrectFormat;
            }
            return code;
        }
    });
});
